import {CatalogSortDto, FilterOption} from "../model/types";

type Params = {
    options: CatalogSortDto[];
};

export const mapCatalogSortOptions = (
    {
        options,
    }: Params
): FilterOption[] => {
    return options.map((option) => ({
        id: option.id,
        label: option.label,
        value: option.value,
        checked: false,
        disabled: false,
        type: "radio"
    }));
};
